import { Footer } from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
import { User } from "lucide-react";

interface SmPCPageProps {
  selectedRegion: string;
  onNewPatient: () => void;
}

export const SmPCPage = ({ selectedRegion, onNewPatient }: SmPCPageProps) => {
  const regionName = selectedRegion.toUpperCase();
  const flagFileName = selectedRegion.toLowerCase();

  return (
    <div className="flex h-screen flex-col items-center justify-center overflow-y-auto bg-gray-50">
      <div className="mb-4 w-full max-w-xl flex-1 text-center">
        {/* ULTOMIRIS Logo */}
        <div className="mb-8 flex justify-center">
          <img
            src="/images/logos/ultomiris-logo.svg"
            alt="ULTOMIRIS"
            className="h-28 w-44"
          />
        </div>

        {/* Title */}
        <h1 className="mb-2 text-2xl font-bold text-gray-800 sm:text-3xl">
          Select Your Region For Full SMPC
        </h1>

        {/* Subtitle */}
        <p className="mb-8 text-lg text-gray-600">
          Select your region to get started with the right information
        </p>

        {/* Region Flag and QR Section */}
        <div className="mb-8">
          {/* Region Flag */}
          <div className="mb-4 flex justify-center">
            <div className="h-20 w-20 overflow-hidden rounded-full sm:h-32 sm:w-32">
              <img
                src={`/images/countries/${flagFileName}.svg`}
                alt={`${regionName} Flag`}
                className="h-full w-full object-cover"
              />
            </div>
          </div>

          {/* QR Code Instructions */}
          <p className="mb-4 text-xl text-gray-700">
            Scan the <span className="font-bold">QR code</span>
            <br />
            for <span className="font-bold">{regionName} SMPC</span>
          </p>

          {/* QR Code */}
          <div className="mb-6 flex justify-center">
            <div className="rounded-lg bg-green-500/60 p-4">
              <img
                src={`/images/smpcs/${flagFileName}-QR-code.png`}
                alt={`QR Code for ${regionName} SMPC`}
                className="h-24 w-24"
              />
            </div>
          </div>
        </div>

        {/* Other Patient Button */}
        <Button
          onClick={onNewPatient}
          className="mx-auto flex w-fit items-center justify-center space-x-2 rounded-full bg-secondary px-12 py-4 font-semibold text-white hover:bg-secondary/80"
        >
          <User className="h-5 w-5" />
          <span>Another patient</span>
        </Button>

        {/* Footer */}
      </div>
      <div className="w-full">
        <Footer />
      </div>
    </div>
  );
};
